<div class="d-flex flex-row justify-content-start gap-32px">
  <div class="flex-1">
    <app-field-label inputId="upload_file" [isMandatory]="true" labelKey="PAGE.LABEL.UPLOAD_FILE"></app-field-label>
    <app-drag-drop-file #dragDrop id="upload_file" (fileChanged)="fileChange($event)" [useViewBtn]="false" [useDownloadBtn]="false" [useDeleteBtn]="false">
    </app-drag-drop-file>
  </div>
  <div class="flex-1 d-flex flex-column align-items-start justify-content-between">
    <div class="upload-guide">
      <p>{{'MICROSITE_UPLOAD.GUIDE.MUST_BE_CONSIDER'|translate}}:</p>
      <ul>
        <li>{{'MICROSITE_UPLOAD.GUIDE.FILE_MUST_BE'|translate:{mime:'.xls'} }}</li>
        <li>{{'MICROSITE_UPLOAD.GUIDE.MAKE_SURE_THE_DATA_IS_MATCH_WITH_FIELD'|translate }}</li>
        <li>{{'MICROSITE_UPLOAD.GUIDE.MAKE_SURE_THE_FIELD_IS_NOT_EMPTY'|translate }}</li>
      </ul>
    </div>
    <div>
      <button (click)="downloadTemplate()"
        class="btn btn-outline btn-outline-secondary text-primary d-flex align-items-center gap-8px">
        <i class="bi bi-box-arrow-in-down fs-5 text-primary"></i>
        {{ 'COMMON.DOWNLOAD_XLS_TEMPLATE' | translate }}
      </button>
    </div>
  </div>
</div>